import { brandGradFillClass } from '@up2stay/up2promo-ui';

/** Initials fallback in workspace/user switchers: brand gradient (handover sidebar mark). */
export const switcherAvatarFallbackClass = brandGradFillClass;
